import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { DialogShowComponent } from './dialog-show/dialog-show.component';
import { DialogSelectSideComponent } from './dialog-select-side/dialog-select-side.component';

@Injectable()
export class DialogsService {

  constructor(private dialog: MatDialog) {
      
   }

  public confirm(title: string, message: string, value: string): Observable<boolean> {
    let dialogRef: MatDialogRef<DialogConfirmComponent>;
  
    dialogRef = this.dialog.open(DialogConfirmComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.value = value;

    return dialogRef.afterClosed();
   }

  public show(title: string, message: string): Observable<boolean> {
    let dialogRef: MatDialogRef<DialogShowComponent>;
  
    dialogRef = this.dialog.open(DialogShowComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
 }

  public logoutWarning(title: string, message: string) {
    let dialogRef: MatDialogRef<DialogShowComponent>;

    dialogRef = this.dialog.open(DialogShowComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef;
  }

  public selectSide() {
    let dialogRef: MatDialogRef<DialogSelectSideComponent>;
    dialogRef = this.dialog.open(DialogSelectSideComponent);

    return dialogRef.afterClosed();
  }

}



// WEBPACK FOOTER //
// ./src/app/dialogs.service.ts